import {Component,Inject, Input, ViewChild} from '@angular/core';
import {ContentPreview} from '../../model/contentPreview';
import {ProjectService} from '../project.service';
import {DOCUMENT} from '@angular/common';
import {TerminalUtil} from '../../util/terminalUtil';
import {Terminal} from '../../model/terminal';
import {Questionnaire} from '../../model/questionnaire';
import {StringUtil} from '../../util/stringUtil';
import {GenericModalComponent} from '../../modal/generic-modal.component';
import {DomSanitizer} from '@angular/platform-browser';

@Component({

    selector: 'content-preview-dialog',
    styles: [
        `
            .modal-dialog {
              max-width: 800px;
              margin:  auto;
            }
            .modal-body{padding-left:50px; padding-right:50px; overflow-y:scroll; height:750px;}

            .emailContent{border-style: solid;border-width: thin;}

            ::-webkit-scrollbar {
              width: 14px;
              height: 5px;
              background-color: #F5F3F0;
            }
            ::-webkit-scrollbar-thumb {
              height: 6px;
              border: 4px solid rgba(0, 0, 0, 0);
              background-clip: padding-box;
              -webkit-border-radius: 7px;
              background-color:#BACEFF;
              -webkit-box-shadow: inset -1px -1px 0px rgba(0, 0, 0, 0.05), inset 1px 1px 0px rgba(0, 0, 0, 0.05);
            }
            ::-webkit-scrollbar-button {
              width: 14px;
              height: 14px;
              display: none;
            }
            ::-webkit-scrollbar-corner {
              background-color: transparent;
            }


            .ContentSection{ padding-left: 20px;}

            .sectionTitle{font-size: large; font-weight: bold;}

            .mainTable{margin-left: 20px;}
            .borderGray{
                border: 1px solid #ccc;
            }

            .borderRed{
                border: 1px solid red;
            }
            .mainTable {width:100%;}
            .twitterTable{
                margin-left: 20px;
            }
            .downloadSection{
             margin-left: 20px;
            }
            .facebookTable{
                margin-left: 20px;
            }
            .modal-footer{background-color:  #ECE8E5;}
            .mailPreviewWindow{height:40px;margin-top:-5px;}

            .modal-header {
              height:56px;
              background-image: url("../../../assets/images/headerBack.jpg");
              color: antiquewhite;
              border-top-right-radius: 10px;
              border-top-left-radius: 10px;
            }
            .modal-content{
              border-top-right-radius: 10px;
              border-top-left-radius: 10px;
              padding-left: 3px;
              padding-right: 3px;
              background-color: #0064FE;
              padding-bottom: 3px;
            }

            .modalBodyContainer{
              background-color:  #ECE8E5;
            }
            .modal-title{margin-left:10px;}
            .closeX{color:azure;size:25px;}
            .closeIcon:hover{ width: 32px;background-image: url("../../../assets/images/closeBtnHovered.png");}

            .btn-outline-danger {
                background-color: #d6462e;
                border-style: solid;
                border-color: white;
                border-width: 2px;
                padding: 0;
            }

            .closeIcon{ width: 32px;background-image: url("../../../assets/images/closeBtn.png");}
            .btn-danger{background-color: #d6462e;border-style: solid;border-color: white;border-width:2px;}
            .btn-danger:hover{background-color: #FF2400;}
            .btn-primary{margin-left: 20px;}
        `
    ],
    template: `
      <div class="modal" tabindex="-1" role="dialog" [style.display]="!hide ? 'inline' : 'none'" style="margin : 20px;"
           xmlns="http://www.w3.org/1999/html">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <!-- header-->
            <div class="modal-header">
                <h4><img *ngIf="isEmail" class="mailPreviewWindow" src="../../assets/images/mailPreview.png" alt="icon">
                <img *ngIf="!isEmail" class="mailPreviewWindow" src="../../assets/images/396.png" alt="icon"></h4>
                <h4 class="modal-title" id="exampleModalLabel">{{title}}</h4>
                <h4 class="closeBtnH4"><button type="button" (click)="closeDialog();" class="btn btn-outline-danger my-2 my-sm-0 closeBtnDiv" data-dismiss="modal" aria-label="Close">
                    <span class="closeX" aria-hidden="true"><img class="closeIcon" alt="closeBtn" src="../../../assets/images/closeBtn.png"></span>
                </button></h4>
            </div>
          <div class="modalBodyContainer">
            <div class="modal-body">
              <!--  <div class="btn-group">
                    <input  style="width:140px;" type="text" [disabled]="true" class="btn btn-outline-primary" formControlName="fontFamily" class="form-control"/>
                    <button class="btn btn-outline-primary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown"
                            aria-haspopup="true" aria-expanded="false">
                    </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        <a *ngFor="lang of langArr" class="dropdown-item" (click)="setFontFamily(msg.key,'arial')">{{lang}}</a>
                        <a class="dropdown-item" (click)="setFontFamily(msg.key,'comic')">Comic</a>
                        <a class="dropdown-item" (click)="setFontFamily(msg.key,'microsoft')">Microsoft</a>
                        <a class="dropdown-item" (click)="setFontFamily(msg.key,'ubuntu')">Ubuntu</a>
                    </div>
                </div>-->

                <div class="top">
                    <p>Select your language for the preview</p>
                    <div>
                        <select [(ngModel)]="this.previewLanguage">
                            <option *ngFor="let lang of langArr" [value]="lang">
                                {{lang}}
                            </option>
                        </select>
                        <button type="button" class="btn btn-primary" (click)="onPreview()">Generate Preview</button>
                    </div>
                </div>
                <br/>
                <br/>
              <ng-container *ngIf="htmlContent != null &&  ( htmlContent.getHtmlContent()!=null || htmlContent.getHtmlContent() !=='')">
                <iframe style="width:100%;height:100%;" [src]="this.sanitizer.bypassSecurityTrustResourceUrl(generateUrl())"></iframe>
              </ng-container>
            </div>
            <!-- footer-->
            <div class="modal-footer ">
            </div>
          </div>
        </div>
    </div>
</div>
<generic-info-modal [hide]="_hideInfoModal" (OkClick)="onOk()" [statusCode]="250"></generic-info-modal>
     `
})
export class ContentPreviewComponent {
    @Input('hide') hide = true;
    @Input('isEmail') isEmail;
    @Input('title') title;

    @Input('terminal') terminal:Terminal;
    @Input('questionnaire') questionnaire:Questionnaire;
    @Input('langArr')  langArr:string[];
    @ViewChild (GenericModalComponent) private genericModal:GenericModalComponent;

    private htmlContent:ContentPreview;
    private _hideInfoModal =true;

    private previewLanguage:string;

    constructor(private _projectService: ProjectService,@Inject(DOCUMENT) public document,private sanitizer:DomSanitizer) {

    }

    onPreview() {

        if(this.previewLanguage==null || this.previewLanguage==='') {
            this.genericModal.defineModal('Please select a language before generating a preview.','Email Preview',250);
            this._hideInfoModal = false;
            return;
        }

        const tmpToken = StringUtil.generateTemporaryToken(this.questionnaire.projectId,this.questionnaire.id,this.terminal.id,TerminalUtil.getTerminalTypeId(this.terminal.type),this.previewLanguage);

        this._projectService.getPreview(tmpToken,this.isEmail,'','',localStorage.getItem('Authorization')).subscribe( (rep)=> {
            console.log(rep);
            // emailHtml as emailPreview;
            this.htmlContent = new ContentPreview();this.htmlContent.setHtmlcontent(rep);

        });
    }

    onOk() {
        this._hideInfoModal = true;
    }
    closeDialog() {
        this.hide = true;
    }

    showDialog() {
        this.hide = false;
    }

  private generateUrl():string {
    return 'http://'+window.location.hostname+':'+window.location.port+'/projects/2/11/windows/13/microsite/site.html';
  }
}
